import { inject } from '@angular/core';
import { Router, CanActivateFn, ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';
import { UserDataService } from '@libs/services/user-data';
import { AuthenticationService } from '../services/authentication.service';

const saveUserDataBeforeRedirect = (
  userDataService: UserDataService,
  childRoute: ActivatedRoute,
) => {
  userDataService.setPromoCode(childRoute.queryParams);
};

export const anonymousGuard: CanActivateFn = (next, state) => {
  const auth = inject(AuthenticationService);
  const userDataService = inject(UserDataService);
  const router = inject(Router);
  const activatedRoute = inject(ActivatedRoute);

  return auth.user$.pipe(
    map((user) => {
      if (!user.loggedIn) {
        return !user.loggedIn;
      } else {
        saveUserDataBeforeRedirect(userDataService, activatedRoute);

        router.navigateByUrl('/');
      }
    }),
  );
};
